const CurrencyCategoryComponent = () => import('@/views/finance/CurrencyCategory/CurrencyCategoryView')

export default [
    {
        path:'/CurrencyCategoryIndex',
        name:'CurrencyCategoryComponent',
        component:CurrencyCategoryComponent
    }
]